import { render, staticRenderFns } from "./setInstallType.vue?vue&type=template&id=15cba47f&scoped=true&"
import script from "./setInstallType.vue?vue&type=script&lang=js&"
export * from "./setInstallType.vue?vue&type=script&lang=js&"
import style0 from "./setInstallType.vue?vue&type=style&index=0&id=15cba47f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cba47f",
  null
  
)

export default component.exports